import { render } from "./ActivateAccountPage.vue?vue&type=template&id=e5a93174"
import script from "./ActivateAccountPage.vue?vue&type=script&lang=js"
export * from "./ActivateAccountPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__